import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi'; // Use correct path: ../../../api/risapi
import { risapi } from './risapi'; // Use correct path: ../../../api/risapi

/**
 * Fetches a list of sales invoices, potentially with filters and pagination.
 */
export const getSalesInvoices = async (filterParameters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/sales-invoices', filterParameters), getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Contains { sales_invoices: [...] }
        }
    } catch (error) {
        handleApiError(error); // Use your global handler
        callback({ error });
    }
};

/**
 * Fetches a single sales invoice by its ID (for viewing).
 */
export const fetchSalesInvoice = async (id, callback) => {
    try {
        const response = await risapi.get(`/api/sales-invoices/${id}`, getAxiosConfig());
        if (response.status === 200) {
            callback(response.data); // Contains { sales_invoice: {...} }
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

/**
 * Creates a new sales invoice (and triggers stock/payment logic).
 */
export const createSalesInvoice = async (newData, callback) => {
    try {
        // Send complex data as JSON
        const response = await risapi.post('/api/sales-invoices', newData, getAxiosConfig());
        if (response.status === 201) {
            callback(response.data); // Contains { sales_invoice: {...} }
        }
    } catch (error) {
        // Pass the full error back to the form's handleApiError
        callback({ error }); 
    }
};


export const getPosProducts = async (callback) => {
    try {
        const response = await risapi.get('/api/products/pos-list', getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};

// Stub for sending invoices (Backend to be implemented later)
export const sendInvoiceNotification = async (invoiceId, method, callback) => {
    // Simulate API call
    console.log(`Sending invoice ${invoiceId} via ${method}`);
    setTimeout(() => {
        callback({ success: true, message: `Invoice sent via ${method}` });
    }, 500);
};


// --- NEW UPDATE METHOD ---
export const updateSalesInvoice = async (id, data, callback) => {
    try {
        const response = await risapi.put(`/api/sales-invoices/${id}`, data, getAxiosConfig());
        if (response.status === 200) { callback(response.data); }
    } catch (error) { callback({ error }); }
};

// --- updateSalesInvoice and destroySalesInvoice are intentionally omitted ---
// As per our design, invoices are not directly updated or deleted.
// They are reversed/adjusted using Credit Notes / Sales Returns.